module.exports = __webpack_public_path__ + "img/spanish_play_store.6f2480c0.png";